import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async generateToken(body: ApiSchemas['GenerateBirdIdTokenDto']) {
    return wrapEndpoint(() =>
      client.POST('/bird-id/token', {
        body,
      }),
    )
  },
  async getToken(physicianId: number) {
    return wrapEndpoint(() =>
      client.GET('/bird-id/token/physician/{physicianId}', {
        params: {
          path: {
            physicianId,
          },
        },
      }),
    )
  },

  async sign(body: ApiSchemas['SignDocumentDto']) {
    return wrapEndpoint(() =>
      client.PATCH('/bird-id/sign', {
        body,
        bodySerializer(body) {
          const fd = new FormData()

          if (body.physicianId !== undefined) fd.append('physicianId', String(body.physicianId))
          if (body.documentId !== undefined) fd.append('documentId', String(body.documentId))
          fd.append('fileData', body.fileData as unknown as File)
          return fd
        },
      }),
    )
  },
}
